import React, { useState } from 'react'
import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from 'react-router-dom'
import Login from './Login/Login'
import Footer from './Home/Footer/Footer'
import Navbar from './Home/Navbar/Navbar'
import AdminDashboard from './Admin/admin'
import Home from './Home/Home'
import Plans from './Home/Plans/plans'
import Class from './Home/Classes/Class'
import Services from './Home/Service/Service'

function App() {
  const [userRole, setUserRole] = useState(null)

  return (
    <Router>
      <AppContent userRole={userRole} setUserRole={setUserRole} />
    </Router>
  )
}

function AppContent({ userRole, setUserRole }) {
  const location = useLocation();
  const showFooter = location.pathname !== '/login';

  return (
    <div className="app">
      {userRole !== 'admin' && userRole !=='user' && <Navbar />}
      <Routes>
        <Route path="/login" element={<Login setUserRole={setUserRole} />} />
        <Route 
          path="/admin-dashboard" 
          element={userRole === 'admin' ? <AdminDashboard /> : <Navigate to="/login" />} 
        />
        <Route path="/plans" element={<Plans />} />
        <Route path="/classes" element={<Class />} />
        <Route path="/services" element={<Services />} />
        <Route 
          path="/" 
          element={
            userRole ? <Navigate to={`/${userRole}-dashboard`} /> : <Home />
          } 
        />
      </Routes>
      {showFooter && userRole !== 'admin'&& userRole !=='user'  && <Footer />}
    </div>
  );
}

export default App
